import React, { useState } from 'react';
import AeroIcon from '../../components/Aero/AeroIcon';
import GlassButton from '../../components/Aero/GlassButton';

/**
 * Unfinished sites (v3 draft rule): drafts only exist after real input, so they
 * live in one folded row above the sites, never in the grid and never in the
 * Live count. The row opens a compact list: name, what was done, when, Resume
 * and delete. A view: the page passes the drafts and the handlers.
 *
 * drafts: [{ id, name, what, when }]
 */
export default function UnfinishedSites({ drafts, onResume, onDiscard, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  if (!drafts.length) return null;
  const n = drafts.length;
  return (
    <section className="aero-unf" aria-label="Unfinished sites">
      <button
        type="button"
        className="aero-unf-row"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <AeroIcon name="clock" />
        <span className="aero-unf-text">
          <b>{n} unfinished</b>
          <span> · {n === 1 ? 'a site you started but did not finish.' : 'sites you started but did not finish.'}</span>
        </span>
        <span className="aero-unf-toggle">
          {open ? 'Hide' : 'Show'}
          <AeroIcon name="down" className={open ? 'is-open' : ''} />
        </span>
      </button>
      {open && (
        <>
          <ul className="aero-unf-list">
            {drafts.map((d) => (
              <li key={d.id} className="aero-unf-item">
                <span className="aero-unf-main">
                  <b>{d.name}</b>
                  <span>{d.what} · {d.when}</span>
                </span>
                <GlassButton fill="glass" size="sm" onClick={() => onResume(d)}>Resume</GlassButton>
                <button
                  type="button"
                  className="aero-unf-del"
                  aria-label={`Delete ${d.name}`}
                  onClick={() => onDiscard(d)}
                >
                  <AeroIcon name="trash" />
                </button>
              </li>
            ))}
          </ul>
          <p className="aero-unf-note">Unfinished items with no input are never saved.</p>
        </>
      )}
    </section>
  );
}
